import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';
import localForage from 'localforage';
import firebase from 'firebase';

import prevention from '@/store/costs/prevention';
import appraisal from '@/store/costs/appraisal';
import internalFailure from '@/store/costs/internalFailure';
import externalFailure from '@/store/costs/externalFailure';
import otherWaste from '@/store/costs/otherWaste';

Vue.use(Vuex);

const state = {
  user: null,
  userIsLoggedIn: false,
  completed: false,
  costSections: [
    prevention,
    appraisal,
    internalFailure,
    externalFailure,
    otherWaste,
  ],
  activeCampaign: {},
};

const mutations = {
  ADD_NEW_COST(state, { index, newCost }) {
    state.costSections[index].costs.push(newCost);
  },
  DELETE_COST(state, { costSectionIndex, costIndex }) {
    state.costSections[costSectionIndex].costs.splice(costIndex, 1);
  },
  RESET_COST_SECTION(state, { costSectionIndex }) {
    const originalStore = JSON.parse(sessionStorage.getItem('storeTemplate'));
    const originalCostSection = originalStore.costSections[costSectionIndex];
    state.costSections[costSectionIndex].costs = originalCostSection.costs;
  },
  RENDER_COMPLETED(state) {
    state.completed = true;
  },
  SET_LOGGED_IN(state, value) {
    state.userIsLoggedIn = value;
  },
  SET_USER(state, userData) {
    state.user = { ...userData };
  },
  SET_CAMPAIGN(state, activeCampaign) {
    state.activeCampaign = { ...activeCampaign };
  },
};

const actions = {
  addNewCost({ commit }, { index, newCost }) {
    commit('ADD_NEW_COST', { index, newCost })
  },
  deleteCost({ commit }, { costSectionIndex, costIndex }) {
    commit('DELETE_COST', { costSectionIndex, costIndex })
  },
  resetCostSection({ commit }, { costSectionIndex, costSectionName }) {
    commit('RESET_COST_SECTION', { costSectionIndex, costSectionName })
  },
  fetchUser({ commit }, { user }) {
    commit('SET_LOGGED_IN', !!user.uid);
    if (user) {
      const userData = {
        displayName: user.displayName,
        email: user.email,
        uid: user.uid,
        refreshToken: user.refreshToken,
      };
      commit('SET_USER', userData);
    } else {
      commit('SET_USER', null);
    }
  },
  fetchActiveCampaign({ commit }) {
    firebase.firestore()
      .collection('campaigns').where('active', '==', true).get()
        .then((querySnapshot) => {
          return querySnapshot.docs.map(doc => doc.data()).pop();
        })
        .then((doc) => {
          commit('SET_CAMPAIGN', doc);
        });
  },
};

const getters = {
  user(state) {
    return state.user;
  },
  userIsLoggedIn(state) {
    return state.userIsLoggedIn;
  },
  activeCampaign(state) {
    return state.activeCampaign;
  },
};

const vuexStorage = new VuexPersist({
  key: 'copq',
  storage: localForage,
});

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [vuexStorage.plugin],
});
